export default function authHeader() {
    const jwt = JSON.parse(localStorage.getItem('authToken'));
    if (jwt) {
        return { 'auth-token': jwt };
    } else {
      return {};
    }
  }